import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const agronomyList = createAsyncThunk('agronomyList', async ({ pageable: data, navigate }) => {

    let cookieUser = SessionManager.getCookie("user");
    let user_details = cookieUser ? JSON.parse(cookieUser) : null;

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `agronomy`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'user_role': "3",
                'customer_id': user_details?.user_role === 2 ? user_details?.id : '',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const agronomyListSlice = createSlice({
    name: 'agronomyList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(agronomyList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(agronomyList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default agronomyListSlice.reducer; 